
// Phase 1: Image Optimization JavaScript

(function() {
  'use strict';

  // Detect WebP support
  function supportsWebP() {
    const canvas = document.createElement('canvas');
    return canvas.toDataURL('image/webp').indexOf('data:image/webp') === 0;
  }

  const webpSupported = supportsWebP();
  console.log('[Image Optimization] WebP support:', webpSupported);

  // Lazy load images with IntersectionObserver
  function initLazyLoading() {
    const images = document.querySelectorAll('img[loading="lazy"]');
    
    if ('IntersectionObserver' in window) {
      const imageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target;
            
            // Load image
            if (img.dataset.src) {
              img.src = img.dataset.src;
            }
            if (img.dataset.srcset) {
              img.srcset = img.dataset.srcset;
            }
            
            // Add width/height if available (prevents CLS)
            if (img.dataset.width && img.dataset.height) {
              img.width = img.dataset.width;
              img.height = img.dataset.height;
            }
            
            img.classList.add('loaded');
            observer.unobserve(img);
          }
        });
      }, {
        rootMargin: '50px'
      });
      
      images.forEach(img => imageObserver.observe(img));
    } else {
      // Fallback for browsers without IntersectionObserver
      images.forEach(img => {
        if (img.dataset.src) img.src = img.dataset.src;
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      });
    }
  }

  // Ensure all product images have dimensions
  function ensureImageDimensions() {
    const images = document.querySelectorAll('img');
    images.forEach(img => {
      if (!img.width && img.naturalWidth) {
        img.width = img.naturalWidth;
      }
      if (!img.height && img.naturalHeight) {
        img.height = img.naturalHeight;
      }
    });
  }

  // Monitor dynamically added images
  function observeDynamicImages() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length) {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) { // Element node
              const images = node.querySelectorAll ? node.querySelectorAll('img') : [];
              images.forEach(img => {
                if (img.loading === 'lazy') {
                  // Re-initialize lazy loading for new images
                  initLazyLoading();
                }
              });
            }
          });
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initLazyLoading();
      ensureImageDimensions();
      observeDynamicImages();
      console.log('[Image Optimization] Initialized');
    });
  } else {
    initLazyLoading();
    ensureImageDimensions();
    observeDynamicImages();
    console.log('[Image Optimization] Initialized');
  }
})();
